import React, { useState } from 'react';
import { Container, Row, Col, Image } from 'react-bootstrap';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
import { Link } from 'react-router-dom';
import BlogContent from '../../data/reshto.json';
import SectionTitle from '../ui/SectionTitle';
import { motion } from 'framer-motion';

export default function BlogPost({ blogClass }) {
    const [BlogItem] = useState(BlogContent);
    return (
        <>
            <motion.section initial={{opacity: 0}} whileInView={{opacity: 1}} transition={{duration: 0.5}} viewport={{once: true}} className={`section ${blogClass || ''}`}>
                <Container fluid>
                    <Row className='justify-content-center'>
                        <Col md={6} className='section-title text-center mb-5'>
                            <SectionTitle title="Instagram Post"/>
                        </Col>
                    </Row>

                    <Row>
                        <Col md={12}>
                            <Swiper
                                spaceBetween={10}
                                autoplay={{
                                    delay: 2500,
                                    disableOnInteraction: false,
                                }}
                                breakpoints={{
                                    0: {
                                        slidesPerView: 2,
                                    },
                                    576: {
                                        slidesPerView: 3,
                                    },
                                    992: {
                                        slidesPerView: 4,
                                    },
                                    1200: {
                                        slidesPerView: 5,
                                    },
                                    1600: {
                                        slidesPerView: 6,
                                    },
                                }}
                                modules={[Autoplay]}
                                className="blog-slider"
                            >
                                {BlogItem.BlogData.map((data, i) =>
                                    <SwiperSlide className='blog-post-item' key={i}>
                                        <Image src={require(`../../images/blog/${data.blogImg}`)} alt="" className='img-fluid w-100 blog-post-img' />
                                        <Link to="/" className='blog-overlay'>
                                            <i className="ri-instagram-line blog-icon"></i>
                                        </Link>
                                    </SwiperSlide>
                                )}
                            </Swiper>
                        </Col>
                    </Row>
                </Container>
            </motion.section>
        </>
    )
}
